module.exports = __webpack_public_path__ + "img/ex-blog-posts.f40b6987.jpg";